import { Component } from "@kluntje/core";
import { addClass, toggleClass } from "@kluntje/js-utils/lib/dom-helpers";
import MediaQueryService from "Services/MediaQueryService";

import debugLayerTemplate from "./fra-e-debug-layer.template"; // eslint-disable-line

/**
 * Custom Element to render an overlay with info regarding the Media Queries and grid
 */

class FRADebugLayer extends Component {
  minimized = false;

  constructor() {
    super({
      ui: {
        showOutlineBtn: ".fra-js-debug-layer__show-outlines",
        mqInfo: ".fra-js-debug-layer__mq-info :-one",
        minimize: ".fra-js-debug-layer__minimize :-one",
      },
      events: [
        {
          event: "click",
          target: "minimize",
          handler: "toggleMinimize",
        },
        {
          event: "change",
          target: "showOutlineBtn",
          handler: "toggleOutline",
        },
        {
          event: "mouseenter",
          target: "showOutlineBtn",
          handler: "showOutline",
        },
        {
          event: "mouseleave",
          target: "showOutlineBtn",
          handler: "toggleOutline",
        },
      ],
      preserveChildren: true,
    });
  }

  connectedCallback() {
    super.connectedCallback();
    /* tslint:disable:max-line-length */
    window.addEventListener(
      "fra-resize",
      _ =>
        (this.ui.mqInfo.innerText = `${window.innerWidth} × ${window.innerHeight} -- ${MediaQueryService.currentMQ}`),
    );
  }

  /**
   * Returns rendering Template
   * @override
   * @returns {string}
   */
  renderingTemplate(): string {
    return debugLayerTemplate();
  }

  toggleMinimize() {
    this.minimized = !this.minimized;
    this.classList.toggle("fra-e-debug-layer--minimized", this.minimized);
  }

  toggleOutline(e: MouseEvent) {
    toggleClass(document.body, "fra-h-show-outline", (e.target as HTMLInputElement).checked);
  }

  showOutline(_e: MouseEvent) {
    addClass(document.body, "fra-h-show-outline");
  }
}
export default FRADebugLayer;

customElements.define("fra-e-debug-layer", FRADebugLayer);
